import "./ResponsiveContainer.css";

const ResponsiveContainer = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default ResponsiveContainer;
